function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { __assign, __spreadArray } from './node_modules/tslib/tslib.es6.js';
import React, { forwardRef, createRef, useRef, useState, useEffect, useImperativeHandle } from 'react';
import { Viewer } from './node_modules/@photo-sphere-viewer/core/index.module.js';
export { AbstractAdapter, AbstractPlugin } from './node_modules/@photo-sphere-viewer/core/index.module.js';
import './styles.css.js';
import './node_modules/@photo-sphere-viewer/core/index.css.js';
import { AutorotatePlugin } from './node_modules/@photo-sphere-viewer/autorotate-plugin/index.module.js';
export { MarkersPlugin } from './node_modules/@photo-sphere-viewer/markers-plugin/index.module.js';
export { CompassPlugin } from './node_modules/@photo-sphere-viewer/compass-plugin/index.module.js';
export { GalleryPlugin } from './node_modules/@photo-sphere-viewer/gallery-plugin/index.module.js';
export { GyroscopePlugin } from './node_modules/@photo-sphere-viewer/gyroscope-plugin/index.module.js';
export { ResolutionPlugin } from './node_modules/@photo-sphere-viewer/resolution-plugin/index.module.js';
export { SettingsPlugin } from './node_modules/@photo-sphere-viewer/settings-plugin/index.module.js';
export { StereoPlugin } from './node_modules/@photo-sphere-viewer/stereo-plugin/index.module.js';
export { VideoPlugin } from './node_modules/@photo-sphere-viewer/video-plugin/index.module.js';
export { VirtualTourPlugin } from './node_modules/@photo-sphere-viewer/virtual-tour-plugin/index.module.js';
export { VisibleRangePlugin } from './node_modules/@photo-sphere-viewer/visible-range-plugin/index.module.js';
export { MapPlugin } from './node_modules/@photo-sphere-viewer/map-plugin/index.module.js';
export { CubemapAdapter } from './node_modules/@photo-sphere-viewer/cubemap-adapter/index.module.js';
export { CubemapTilesAdapter } from './node_modules/@photo-sphere-viewer/cubemap-tiles-adapter/index.module.js';
export { CubemapVideoAdapter } from './node_modules/@photo-sphere-viewer/cubemap-video-adapter/index.module.js';
export { EquirectangularTilesAdapter } from './node_modules/@photo-sphere-viewer/equirectangular-tiles-adapter/index.module.js';
export { EquirectangularVideoAdapter } from './node_modules/@photo-sphere-viewer/equirectangular-video-adapter/index.module.js';
export { LensflarePlugin } from './node_modules/photo-sphere-viewer-lensflare-plugin/dist/index.module.js';
import './node_modules/@photo-sphere-viewer/markers-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/compass-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/gallery-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/settings-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/video-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/virtual-tour-plugin/index.css.js';
import './node_modules/@photo-sphere-viewer/map-plugin/index.css.js';
import EventEmitter from './node_modules/eventemitter3/index.js';
var eventEmitter = new EventEmitter();
var Emitter = {
  on: function on(event, fn) {
    return eventEmitter.on(event, fn);
  },
  once: function once(event, fn) {
    return eventEmitter.once(event, fn);
  },
  off: function off(event, fn) {
    return eventEmitter.off(event, fn);
  },
  emit: function emit(event, payload) {
    return eventEmitter.emit(event, payload);
  }
};
Object.freeze(Emitter);
var omittedProps = ["src", "height", "width", "containerClass", "littlePlanet", "onPositionChange", "onZoomChange", "onClick", "onDblclick", "onReady"];
var defaultNavbar = ["autorotate", "zoom", "fullscreen"];
function adaptOptions(options) {
  var adaptedOptions = __assign({}, options);
  for (var key in adaptedOptions) {
    if (omittedProps.includes(key)) {
      delete adaptedOptions[key];
    }
  }
  return adaptedOptions;
}
function map(_in, inMin, inMax, outMin, outMax) {
  return (_in - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
function filterNavbar(navbar) {
  if (navbar == null) return defaultNavbar;
  if (!Array.isArray(navbar)) {
    if (typeof navbar === "string") {
      return navbar === "" ? false : [navbar];
    }
    return navbar ? defaultNavbar : false;
  }
  return navbar;
}
var ReactPhotoSphereViewer = /*#__PURE__*/forwardRef(function (options, ref) {
  var sphereElementRef = /*#__PURE__*/createRef();
  var spherePlayerInstance = useRef(null);
  var LITTLEPLANET_MAX_ZOOM = 130;
  var LITTLEPLANET_DEF_LAT = useState(-90)[0];
  var LITTLEPLANET_FISHEYE = useState(2)[0];
  var LITTLEPLANET_DEF_ZOOM = useState(0)[0];
  var _a = useState(defaultNavbar),
    currentNavbar = _a[0],
    setCurrentNavbar = _a[1];
  useEffect(function () {
    function handleResize() {
      var aspectRatio = window.innerWidth / window.innerHeight;
      //console.log(aspectRatio)
      LITTLEPLANET_MAX_ZOOM = Math.floor(map(aspectRatio, 0.5, 1.8, 140, 115));
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(function () {
    var _a, _b, _d, _e;
    var littlePlanetEnabled = true;
    if (sphereElementRef.current && !spherePlayerInstance.current) {
      var _c_1 = new Viewer(__assign(__assign({}, adaptOptions(options)), {
        container: sphereElementRef.current,
        panorama: options.src,
        size: {
          height: options.height,
          width: options.width || "100px"
        },
        fisheye: options.littlePlanet ? LITTLEPLANET_FISHEYE : options.fisheye || false,
        minFov: options.minFov || 30,
        maxFov: options.littlePlanet ? LITTLEPLANET_MAX_ZOOM : options.maxFov || 90,
        defaultZoomLvl: options.littlePlanet ? LITTLEPLANET_DEF_ZOOM : options.defaultZoomLvl || 50,
        defaultYaw: options.defaultYaw || 0,
        defaultPitch: options.littlePlanet ? LITTLEPLANET_DEF_LAT : options.defaultPitch || 0,
        sphereCorrection: options.sphereCorrection || {
          pan: 0,
          tilt: 0,
          roll: 0
        },
        moveSpeed: options.moveSpeed || 1,
        zoomSpeed: options.zoomSpeed || 1,
        // when it undefined, = true, then use input value.
        // The input value maybe false, value || true => false => true
        moveInertia: (_a = options.moveInertia) !== null && _a !== void 0 ? _a : true,
        mousewheel: options.littlePlanet ? false : (_b = options.mousewheel) !== null && _b !== void 0 ? _b : true,
        mousemove: (_d = options.mousemove) !== null && _d !== void 0 ? _d : true,
        mousewheelCtrlKey: options.mousewheelCtrlKey || false,
        touchmoveTwoFingers: options.touchmoveTwoFingers || false,
        useXmpData: (_e = options.useXmpData) !== null && _e !== void 0 ? _e : true,
        panoData: options.panoData || {},
        requestHeaders: options.requestHeaders || {},
        canvasBackground: options.canvasBackground || "#000",
        withCredentials: options.withCredentials || false,
        navbar: filterNavbar(options.navbar),
        lang: options.lang || {},
        keyboard: options.keyboard || {},
        plugins: __spreadArray([[AutorotatePlugin, {
          autorotatePitch: "5deg",
          autostartDelay: undefined,
          autostartOnIdle: false
        }]], options.plugins ? options.plugins : [], true)
      }));
      _c_1.addEventListener("ready", function () {
        if (options.onReady) {
          options.onReady(_c_1);
        }
      }, {
        once: true
      });
      _c_1.addEventListener("click", function (data) {
        if (options.onClick) {
          options.onClick(data, _c_1);
        }
        if (options.littlePlanet && littlePlanetEnabled) {
          littlePlanetEnabled = false;
          // fly inside the sphere
          _c_1.animate({
            yaw: 0,
            pitch: LITTLEPLANET_DEF_LAT,
            zoom: 75,
            speed: "3rpm"
          }).then(function () {
            // watch on the sky
            _c_1.animate({
              yaw: 0,
              pitch: 0,
              zoom: 90,
              speed: "10rpm"
            }).then(function () {
              var _a;
              // Disable Little Planet.
              var p = _c_1.getPlugin("autorotate");
              if (p) p.start();
              _c_1.setOption("maxFov", options.maxFov || 70);
              _c_1.setOption("mousewheel", (_a = options.mousewheel) !== null && _a !== void 0 ? _a : true);
            });
          });
        }
      });
      _c_1.addEventListener("dblclick", function (data) {
        if (options.onDblclick) {
          options.onDblclick(data, _c_1);
        }
      });
      _c_1.addEventListener("zoom-updated", function (zoom) {
        if (options.onZoomChange) {
          options.onZoomChange(zoom, _c_1);
        }
      });
      _c_1.addEventListener("position-updated", function (position) {
        if (options.onPositionChange) {
          options.onPositionChange(position.position.pitch, position.position.yaw, _c_1);
        }
      });
      if (options.littlePlanet) {
        var resetLittlePlanetButton = {
          id: "resetLittlePlanetButton",
          content: "🪐",
          title: "Reset Little Planet",
          className: "resetLittlePlanetButton",
          onClick: function onClick() {
            littlePlanetEnabled = true;
            var p = _c_1.getPlugin("autorotate");
            if (p) p.stop();
            _c_1.setOption("maxFov", LITTLEPLANET_MAX_ZOOM);
            //_c.setOption("fisheye", LITTLEPLANET_FISHEYE) // @ts-ignore ts(2345)
            _c_1.setOption("mousewheel", false);
            _c_1.animate({
              yaw: 0,
              pitch: LITTLEPLANET_DEF_LAT,
              zoom: LITTLEPLANET_DEF_ZOOM,
              speed: "10rpm"
            });
          }
        };
        var _currentNavbar = filterNavbar(options.navbar);
        if (_currentNavbar !== false && !_currentNavbar.find(function (item) {
          return _typeof(item) === "object" && (item === null || item === void 0 ? void 0 : item.id) === "resetLittlePlanetButton";
        })) {
          _currentNavbar.push(resetLittlePlanetButton);
          _c_1.setOption("navbar", _currentNavbar);
          setCurrentNavbar(_currentNavbar);
        }
      }
      Emitter.on("animate", function (options) {
        _c_1.animate(options);
      }).on("stop-animation", function () {
        _c_1.stopAnimation();
      }).on("destroy", function () {
        _c_1.destroy();
      }).on("rotate", function (options) {
        _c_1.rotate(options);
      }).on("setOption", function (pair) {
        var option = pair.option,
          value = pair.value;
        _c_1.setOption(option, value);
      }).on("zoom", function (zoom) {
        _c_1.zoom(zoom);
      }).on("zoomIn", function () {
        _c_1.zoomIn();
      }).on("zoomOut", function () {
        _c_1.zoomOut();
      }).on("startAutoRotate", function () {
        var p = _c_1.getPlugin("autorotate");
        if (p) p.start();
      }).on("stopAutoRotate", function () {
        var p = _c_1.getPlugin("autorotate");
        if (p) p.stop();
      }).on("toggleAutorotate", function () {
        var p = _c_1.getPlugin("autorotate");
        if (p) p.toggle();
      });
      spherePlayerInstance.current = _c_1;
    }
  }, [sphereElementRef, options]);
  // Methods
  useImperativeHandle(ref, function () {
    return {
      animate: function animate(options) {
        Emitter.emit("animate", options);
      },
      destroy: function destroy() {
        Emitter.emit("destroy", {});
      },
      rotate: function rotate(options) {
        Emitter.emit("rotate", options);
      },
      setOption: function setOption(option, value) {
        Emitter.emit("setOption", {
          option: option,
          value: value
        });
      },
      setOptions: function setOptions(options) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.setOptions(options);
      },
      getCurrentNavbar: function getCurrentNavbar() {
        return currentNavbar;
      },
      zoom: function zoom(value) {
        Emitter.emit("zoom", value);
      },
      zoomIn: function zoomIn() {
        Emitter.emit("zoomIn", {});
      },
      zoomOut: function zoomOut() {
        Emitter.emit("zoomOut", {});
      },
      resize: function resize(size) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.resize(size);
      },
      enterFullscreen: function enterFullscreen() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.enterFullscreen();
      },
      exitFullscreen: function exitFullscreen() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.exitFullscreen();
      },
      toggleFullscreen: function toggleFullscreen() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.toggleFullscreen();
      },
      isFullscreenEnabled: function isFullscreenEnabled() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.isFullscreenEnabled();
      },
      startAutoRotate: function startAutoRotate() {
        Emitter.emit("startAutoRotate", {});
      },
      stopAutoRotate: function stopAutoRotate() {
        Emitter.emit("stopAutoRotate", {});
      },
      getPlugin: function getPlugin(pluginName) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.getPlugin(pluginName);
      },
      getPosition: function getPosition() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.getPosition();
      },
      getZoomLevel: function getZoomLevel() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.getZoomLevel();
      },
      getSize: function getSize() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.getSize();
      },
      needsUpdate: function needsUpdate() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.needsUpdate();
      },
      autoSize: function autoSize() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.autoSize();
      },
      setPanorama: function setPanorama(path, options) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.setPanorama(path, options);
      },
      setOverlay: function setOverlay(path, opacity) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.setOverlay(path, opacity);
      },
      toggleAutorotate: function toggleAutorotate() {
        Emitter.emit("toggleAutorotate", {});
      },
      showError: function showError(message) {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.showError(message);
      },
      hideError: function hideError() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.hideError();
      },
      startKeyboardControl: function startKeyboardControl() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.startKeyboardControl();
      },
      stopKeyboardControl: function stopKeyboardControl() {
        var _a;
        return (_a = spherePlayerInstance.current) === null || _a === void 0 ? void 0 : _a.stopKeyboardControl();
      }
    };
  }, [spherePlayerInstance.current, sphereElementRef, options, ref]);
  return /*#__PURE__*/React.createElement("div", {
    className: options.containerClass || "view-container",
    ref: sphereElementRef
  });
});
export { ReactPhotoSphereViewer };
//# sourceMappingURL=index.js.map
